export type TopMetric =
  | 'CifraDeAfaceriNeta'
  | 'ProfitBrut'
  | 'ProfitNet'
  | 'NumarMediuDeSalariati'
  | 'ActiveImobilizate'
  | 'ActiveCirculante'
  | 'Datorii'
  | 'Capitaluri'
  | 'VenituriTotale'
  | 'CheltuieliTotale'
  | 'Stocuri'
  | 'Creante'
  | 'CasaSiConturiLaBanci'
  | 'PierdereBruta'
  | 'PierdereNeta'
  | 'CapitalSubscrisVarsat'
  | 'Provizioane';

export const TOP_METRIC_LABELS: Record<string, string> = {
  CifraDeAfaceriNeta: 'Cifra de afaceri',
  ProfitBrut: 'Profit brut',
  ProfitNet: 'Profit net',
  NumarMediuDeSalariati: 'Numar angajati',
  ActiveImobilizate: 'Active imobilizate',
  ActiveCirculante: 'Active circulante',
  Datorii: 'Datorii',
  Capitaluri: 'Capitaluri',
  VenituriTotale: 'Venituri totale',
  CheltuieliTotale: 'Cheltuieli totale',
  Stocuri: 'Stocuri',
  Creante: 'Creante',
  CasaSiConturiLaBanci: 'Lichiditati',
  PierdereBruta: 'Pierdere bruta',
  PierdereNeta: 'Pierdere neta',
  CapitalSubscrisVarsat: 'Capital social',
  Provizioane: 'Provizioane',
};

export interface TopParams {
  metric: TopMetric;
  year: number;
  first: number;
  rows: number;
  caen?: string;
  countyCode?: number;
  cityCode?: number;
}

export interface TopResponse {
  category: string;
  metric: string;
  year: number;
  totalCompanies: number;
  companies: TopCompany[];
}

export interface TopCompany {
  rank: number;
  cui: string | null;
  name: string | null;
  codCaen: string | null;
  county: string | null;
  city: string | null;
  metricValue: number | null;
}
